import { render, staticRenderFns } from "./PriceBasedRate.vue?vue&type=template&id=742406f0&"
import script from "./PriceBasedRate.vue?vue&type=script&lang=js&"
export * from "./PriceBasedRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports